import React from 'react';
import { MapPinIcon, PhoneIcon } from 'lucide-react';
export function GetInTouchSection() {
  return <div className="lg:pl-8" data-id="element-2653">
      <div className="bg-gray-50 rounded-lg p-8 border border-gray-200" data-id="element-2654">
        <h3 className="text-2xl font-bold text-navy mb-6" data-id="element-2655">Get In Touch</h3>
        <div className="space-y-6" data-id="element-2656">
          <div className="flex items-start" data-id="element-2657">
            <MapPinIcon className="w-6 h-6 text-orange mr-4 flex-shrink-0 mt-1" data-id="element-2658" />
            <div data-id="element-2659">
              <p className="font-semibold text-gray-900 mb-1" data-id="element-2660">Address</p>
              <p className="text-gray-700" data-id="element-2661">
                28221 Beck Road, Unit A2
                <br data-id="element-2662" />
                Wixom, Michigan 48393
              </p>
            </div>
          </div>
          <div className="flex items-start" data-id="element-2663">
            <PhoneIcon className="w-6 h-6 text-orange mr-4 flex-shrink-0 mt-1" data-id="element-2664" />
            <div data-id="element-2665">
              <p className="font-semibold text-gray-900 mb-1" data-id="element-2666">Phone</p>
              <a href="tel:2483800871" className="text-blue hover:text-orange transition-colors font-medium text-lg" data-id="element-2667">
                (248) 380-0871
              </a>
            </div>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-300" data-id="element-2668">
          <p className="text-sm text-gray-600 leading-relaxed" data-id="element-2669">
            Our team is ready to help you find the right CNC machine tools for
            your manufacturing needs. Our team will follow up promptly.
          </p>
        </div>
      </div>
    </div>;
}